import template from './news-detail.html';
import controller from './news-detail.controller';

let newsDetailComponent = {
  bindings: {},
  template,
  controller
};

export default newsDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/news/news-detail.component.js